$(document).ready(function () {

    if (window.location.href.includes("etrennes")) {

        // Date de fin de l'événement
        const targetDate = new Date("December 31, 2024 23:59:59").getTime();

        function updateCountdown() {
            const now = new Date().getTime();
            const timeLeft = targetDate - now;

            // Calcul des jours, heures, minutes, secondes restants
            const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

            // Mise à jour des éléments HTML
            document.getElementById("days").textContent = days.toString().padStart(2, "0");
            document.getElementById("hours").textContent = hours.toString().padStart(2, "0");
            document.getElementById("minutes").textContent = minutes.toString().padStart(2, "0");
            document.getElementById("seconds").textContent = seconds.toString().padStart(2, "0");

            // Vérification si la date cible est atteinte
            if (timeLeft < 0) {
                clearInterval(countdownInterval);
                document.querySelector(".countdown").innerHTML = "<h1>Inscriptions fermées !</h1>";
            }
        }

        // Mise à jour du compte à rebours toutes les secondes
        const countdownInterval = setInterval(updateCountdown, 1000);
    }
});
